export const DOCUMENT_STATUS_KEY = {
  DRAFT: 'draft',
  PROCESSING: 'processing',
  CANCELED: 'canceled',
  COMPLETED: 'completed',
  ABORTED: 'aborted',
};

export type TokenStatus = 'justSigned' | 'confirmed' | 'expired' | 'rejected' | 'aborted' | 'readonly' | 'forwarded';

export type TokenInfo = {
  action: string;
  appUrl: string;
  contractId: number;
  contractName?: string;
  email: string;
  exp: number;
  iat: number;
  issuerName: 'ParticipantTokenIssuer' | 'SharingTokenIssuer';
  partyId: number;
  uuid: string;
  role?: string;
};
export type SigningType = 'drawSignature' | 'singpass';
